export default function Box() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M10.1449 2.32909C10.5191 2.11349 10.9433 2 11.3751 2C11.807 2 12.2313 2.1135 12.6054 2.32912L12.6071 2.33011L18.3563 5.61538C18.4904 5.69277 18.6163 5.78229 18.7326 5.88253L11.375 10.0868L4.01758 5.88257C4.13393 5.78232 4.25985 5.69278 4.39391 5.61539L4.39708 5.61355L10.1449 2.32909Z"
        fill="currentColor"
      />
      <path
        d="M3.2014 7.30859C3.17518 7.45271 3.16177 7.59942 3.16162 7.74704V14.3193C3.16206 14.7513 3.27612 15.1757 3.49236 15.5498C3.7086 15.9239 4.0194 16.2346 4.3936 16.4507L4.39677 16.4525L10.1428 19.7359L10.1444 19.7368C10.2752 19.8122 10.4122 19.8751 10.5535 19.9251V11.5098L3.2014 7.30859Z"
        fill="currentColor"
      />
      <path
        d="M12.1963 19.9251C12.3376 19.8752 12.4746 19.8122 12.6055 19.7368L12.6069 19.736L18.353 16.4525L18.3562 16.4507C18.7304 16.2346 19.0412 15.924 19.2574 15.5499C19.4737 15.1758 19.5878 14.7514 19.5882 14.3194V7.7471C19.588 7.59946 19.5746 7.45273 19.5484 7.30859L12.1963 11.5098V19.9251Z"
        fill="currentColor"
      />
    </svg>
  );
}
